export interface IInventoryEquipmentType {
  companies: unknown[];
  equipmentTypeID: string;
  name: string;
  requirements: unknown[];
  bActive: boolean;
}
